const menu = [
    {
        title: "首页",
        icon: "icon-shouye",
        path: "/index"
    },
    {
        title: "费用查缴",
        icon: "icon-feiyongchajiao",
        path: "/fee-enquiry/index"
    },
    {
        title: "水表管理",
        icon: "icon-shuibiaoguanli",
        path: "/meter-manage/index"
    },
    {
        title: "业务办理",
        icon: "icon-gongzhonghaowenti",
        path: "/business-hand/index"
    },
    {
        title: "问题反馈",
        icon: "icon-gerenzhongxin",
        path: "/problem-feedback/index"
    },
    {
        title: "个人中心",
        icon: "icon-shouye",
        path: "/index"
    },
];

export default menu